// @flow

import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {actionsRolesAllow} from './ActionsRolesAllow';
import type {RoleDescriptionProps} from './RoleDescription';
import supportSpecialistRoleDescriptionProps from './SupportSpecialistRoleDescription';

const supportOnlyRoleMessages = defineMessages({
  roleName: {
    id: 'docsApp.components.contrib.roleDescriptions.supportOnly.roleName',
    description: 'The name of the support only role.',
    defaultMessage: 'Support Only',
  },
  shortDescription: {
    id:
      'docsApp.components.contrib.roleDescriptions.supportOnly.shortDescription',
    description: 'The short description of the support only role.',
    defaultMessage: 'Can access the support center',
  },
  descriptionOfWhatRoleCanDo: {
    id:
      'docsApp.components.contrib.roleDescriptions.supportOnly.descriptionOfWhatRoleCanDo',
    description: 'The description of what the support only role can do.',
    defaultMessage:
      'This role is for people who need to use the support center.',
  },
  descriptionOfWhatRoleCannotDo: {
    id:
      'docsApp.components.contrib.roleDescriptions.supportOnly.descriptionOfWhatRoleCannotDo',
    description: "The description of what the support only role can't do.",
    defaultMessage: "They can't do anything that's not related to support.",
  },
});

const supportOnlyRoleDescriptionProps: RoleDescriptionProps = {
  roleName: <FormattedMessage {...supportOnlyRoleMessages.roleName} />,
  roleExternalId: 'support_only',
  isBeta: true,
  descriptionOfWhatRoleCanDo: (
    <FormattedMessage {...supportOnlyRoleMessages.descriptionOfWhatRoleCanDo} />
  ),
  descriptionOfWhatRoleCannotDo: (
    <FormattedMessage
      {...supportOnlyRoleMessages.descriptionOfWhatRoleCannotDo}
    />
  ),
  someThingsThisRoleCanDo: [
    <FormattedMessage {...actionsRolesAllow.viewSupportHistory} />,
    <FormattedMessage {...actionsRolesAllow.manageSupportRequests} />,
  ],
  someThingsThisRoleCannotDo: [
    <FormattedMessage {...actionsRolesAllow.editAccountDetails} />,
    <FormattedMessage {...actionsRolesAllow.addAndEditBankAccountDetails} />,
    <FormattedMessage {...actionsRolesAllow.configureAnyProductSettings} />,
    <FormattedMessage {...actionsRolesAllow.createEditDeleteAPIKeys} />,
    <FormattedMessage {...actionsRolesAllow.createViewRefundPayments} />,
    <FormattedMessage {...actionsRolesAllow.viewPayouts} />,
    <FormattedMessage {...actionsRolesAllow.viewAndResolveDisputes} />,
    <FormattedMessage {...actionsRolesAllow.createViewEditDeleteProducts} />,
    <FormattedMessage {...actionsRolesAllow.createViewEditDeleteCustomers} />,
    <FormattedMessage
      {...actionsRolesAllow.createViewEditRejectConnectedAccounts}
    />,
    <FormattedMessage {...actionsRolesAllow.viewEventsAndLogs} />,
    <FormattedMessage {...actionsRolesAllow.anythingBesidesSupport} />,
  ],
};

export const allSupportRoleProps = [
  supportSpecialistRoleDescriptionProps,
  supportOnlyRoleDescriptionProps,
];
